module.exports = __webpack_public_path__ + "img/has.fdedba80.png";